import styled from 'styled-components'
import media from 'styles/media'
import Colors from 'styles/Colors'
import bulletLines from 'svg/bulletLines.svg'
import bulletLinesL from 'svg/bulletLinesL.svg'

export const HeadlineXL = styled.h1`
  font-family: 'Maison Neue';
  font-style: medium;
  font-size: 121px;
  line-height: 100%;
  letter-spacing: -0.01em;
  font-weight: 500;
  color: ${Colors.trueBlack};
  ${media.fullWidth} {
    font-size: 7.2vw;
  }
  ${media.tablet} {
  }
`

export const HeadlineL = styled.h1`
  font-family: 'Maison Neue';
  font-size: 81px;
  line-height: 100%;
  letter-spacing: -0.005em;
  color: ${Colors.trueBlack};
  ${media.fullWidth} {
    font-size: 4.8vw;
  }
  ${media.tablet} {
  }
`
export const HeadlineM = styled.h1`
  font-family: 'Maison Neue';

  font-size: 54px;
  line-height: 104%;
  font-weight: 500;
  color: ${Colors.trueBlack};
  ${media.fullWidth} {
    font-size: 3.2vw;
  }
  ${media.mobile} {
    // font-size: 9.6vw;
    // line-height: 100%;
  }
`
export const HeadlineS = styled.h1`
  font-family: 'Maison Neue';

  font-size: 36px;
  line-height: 100%;
  letter-spacing: -0.0015em;
  color: ${Colors.trueBlack};
  ${media.fullWidth} {
    font-size: 2.1vw;
  }
  ${media.tablet} {
  }
`
export const Subtitle = styled.h1`
  font-family: 'Maison Neue';
  font-size: 24px;
  line-height: 117%;
  font-style: normal;
  font-weight: 500;
  color: ${Colors.trueBlack};
  ${media.fullWidth} {
    font-size: 1.4vw;
  }
  ${media.tablet} {
  }
`
export const Subtitle2 = styled.h1`
  font-family: 'Maison Neue';

  font-size: 16px;
  font-weight: 700;
  line-height: 150%;
  letter-spacing: 0.03125em;
  color: ${Colors.trueBlack};
  ${media.fullWidth} {
    font-size: 1vw;
  }

  ${media.tablet} {
  }
`

export const Overline = styled.p<{ bullet?: boolean }>`
  font-family: 'Maison Neue';
  font-size: 14px;
  font-style: normal;
  font-weight: normal;
  color: ${Colors.softBlack};
  line-height: 114%;
  letter-spacing: 0.05357em;
  text-transform: uppercase;
  color: ${Colors.softBlack};
  position: relative;
  padding-left: ${(props) => (props.bullet ? '20px' : 0)};
  ${media.fullWidth} {
    font-size: 0.9vw;
    padding-left: ${(props) => (props.bullet ? '1vw' : 0)};
  }
  ::after {
    white-space: nowrap;
    color: ${Colors.rossoCorsa};
    content: ${(props) => (props.bullet ? "'//'" : '')};
    font-size: 14px;
    display: inline-block;
    position: absolute;
    left: 0;
  }
  ${media.tablet} {
  }
`
export const SubtitleS = styled.p<{ bullet?: boolean }>`
  font-family: 'Maison Neue';

  font-size: 24px;
  line-height: 117%;
  font-style: normal;
  font-weight: 500;
  position: relative;
  :after {
    content: ${(props) => (props.bullet ? `url(${bulletLinesL})` : '')};
    position: absolute;
    left: -30px;
    top: 5px;
    width: 19px;
  }
  ${media.fullWidth} {
    font-size: 1.4vw;
    ::after {
      left: -1.9vw;
      top: 0.3vw;
      width: 1.1vw;
    }
  }
  ${media.tablet} {
    :after {
      top: 2px;
    }
  }
`
export const Body = styled.p`
  font-family: 'Maison Neue Mono';
  font-size: 16px;
  line-height: 150%;
  letter-spacing: 0.05357em;
  font-weight: 400;
  color: ${Colors.softBlack};
  ${media.fullWidth} {
    font-size: 1vw;
  }
  ${media.tablet} {
  }
`
export const Body2 = styled.p`
  font-family: 'Maison Neue Mono';
  font-size: 24px;
  line-height: 150%;
  font-weight: 400;
  color: ${Colors.softBlack};
  ${media.fullWidth} {
    font-size: 1.4vw;
  }
  ${media.tablet} {
  }
`
export const Body3 = styled.p`
  font-family: 'Maison Neue';

  font-size: 16px;
  line-height: 150%;
  font-style: normal;
  font-weight: 500;
  color: ${Colors.softBlack};

  ${media.fullWidth} {
    font-size: 1vw;
  }
  ${media.tablet} {
  }
`

export const Caption = styled.p`
  font-family: 'Maison Neue Mono';
  font-size: 12px;
  line-height: 100%;
  letter-spacing: 0.0417em;
  font-weight: bold;
  color: ${Colors.softBlack};
  ${media.fullWidth} {
    font-size: 0.7vw;
  }
  ${media.tablet} {
  }
`

export const Link = styled.a`
  font-family: 'Maison Neue';
  font-size: 16px;
  line-height: 150%;
  font-weight: 500;
  color: ${Colors.softBlack};
  ${media.fullWidth} {
    font-size: 1vw;
  }
  ${media.tablet} {
  }
`
export const LinkArrow = styled.a`
  font-family: 'Maison Neue';
  font-size: 16px;
  line-height: 150%;
  font-weight: 400;
  color: ${Colors.softBlack};
  ${media.fullWidth} {
    font-size: 1vw;
  }
  ${media.tablet} {
  }
`

export const TextLink = styled.a`
  font-family: 'Maison Neue Mono';
  font-style: normal;
  font-weight: bold;
  text-decoration: underline;
  font-size: 16px;
  line-height: 150%;
  ${media.fullWidth} {
    font-size: 1vw;
  }
  ${media.tablet} {
  }
`

export const HyperLink = styled.a`
  font-family: 'Maison Neue Mono';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 150%;
  text-decoration-line: underline;

  color: ${Colors.softBlack};
  ${media.fullWidth} {
    font-size: 1vw;
  }
  ${media.tablet} {
  }
`
export const TransparentTextString = `
  text-fill-color: transparent;
  -webkit-background-clip: text;
  -moz-background-clip: text;
  -webkit-text-fill-color: transparent;
  -moz-text-fill-color: transparent;
  background-size: 100%;
  background-clip: text;
  -webkit-text-stroke-color: ${Colors.whiteSmoke};
  background-color: rgba(0, 0, 0, 0);
  -webkit-text-stroke-width: 1px;
`
export const StrikeThroughStyles = `
width: fit-content;
position: relative;


:after {
  content: '';
  position: absolute;
  width: 0;
  height: 2px;
  top: 50%;
  left: -7px;
  border: none;
  background: ${Colors.rossoCorsa};
  transition: 0.8s;
  transition-timing-function: cubic-bezier(0.72, 0, 0.12, 1);
}


:hover:after {
  width: calc(100% + 14px);
}
`

export const StrikeThroughTransparentStyles = `
${StrikeThroughStyles}
text-fill-color: transparent;
-webkit-background-clip: text;
-moz-background-clip: text;
-webkit-text-fill-color: transparent;
-moz-text-fill-color: transparent;
background-clip: text;
background-color: ${Colors.trueBlack};
-webkit-text-stroke-width: 0;
-webkit-text-stroke-color: rgba(0, 0, 0, 0);
-webkit-text-stroke-color: ${Colors.trueBlack};
background-size: 100%;
transition: 0.8s;
transition-timing-function: cubic-bezier(0.72, 0, 0.12, 1);
:hover {
  -webkit-text-stroke-width: 1px;
  background-color: rgba(0, 0, 0, 0);
  transition: 0.8s;
  transition-timing-function: cubic-bezier(0.72, 0, 0.12, 1);
}

`
